<template>
  <div>
  <!-- 优选服务 -->
    <van-list v-model="loading" :finished="finished" @load="loadMore">
      <div class="list">
        <RecommendedDemo v-for="item in pageList" :key="item.serviceId" :msg="item"></RecommendedDemo>
      </div>
    </van-list>
  <!-- 优选服务 -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import RecommendedDemo from '../components/RecommendedDemo';

export default {
  data() {
    return{
      pageList: [],
      pageIndex: 1,
      pageTotal: 0,
      loading: false,
      finished: false,
    }
  },
  methods: {
    getList() {  // 获取优选服务列表
      this.$http.post(`${this.URL_PREFIX}/app/get/fine/service/info/list`, {
        parkId: this.currentParkId,
        currPage: this.pageIndex,
        pageRows: 10,
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          const tempArr = res.resData.pageList ? res.resData.pageList : [];
          this.pageList = this.pageList.concat(tempArr);
          this.pageTotal = res.resData.pageInfo ? res.resData.pageInfo.total : 0;
          this.finished = this.pageList.length >= this.pageTotal ? true : false;
        }
        this.loading = false;
      });
    },
    loadMore() {
      if (this.pageList.length >= this.pageTotal) {
        return;
      }
      this.loading = true;
      this.pageIndex++;
      this.getList();
    }
  },
  mounted() {
    this.getList();
  },
  computed: {
    ...mapGetters(['currentParkId']),
  },
  components: {
    RecommendedDemo
  },
}
</script>

<style lang="scss" scoped>
.list {
  padding-bottom: .32rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/business/child/Recommend.vue